import {
  EksisterendeRegistrering,
  ForetakMedLenker,
} from "../infrastructure/api/api";
import { useCallback, useState } from "react";
import { findURIAndReplaceOrigin } from "../infrastructure/entrypoint/link";
import { getJSON } from "../infrastructure/api/digipost-fetch";
import { useUnrecoverableError } from "../infrastructure/errors/useUnrecoverableError";
import { useNavigate } from "react-router";
import { Route } from "../infrastructure/routing/routes";
import { useIntegrasjonsPartner } from "../PartnerOnboarding/useIntegrasjonsPartner";

export function useValgtForetak(callBack: () => void) {
  const { integrasjonsPartner } = useIntegrasjonsPartner();
  const [valgtForetak, setValgtForetak] = useState<ForetakMedLenker>();
  const [alleredeRegistrert, setAlleredeRegistrert] = useState(false);
  const [velgerForetak, setVelgerForetak] = useState(false);
  const { setCustomError } = useUnrecoverableError();
  const navigate = useNavigate();

  const getErRegistrert = (foretak: ForetakMedLenker) => {
    const url = findURIAndReplaceOrigin("er-registrert", foretak._links);
    return getJSON<EksisterendeRegistrering>(url);
  };

  const velgForetak = useCallback(
    (foretak: ForetakMedLenker) => {
      setAlleredeRegistrert(false);
      setVelgerForetak(true);

      getErRegistrert(foretak)
        .then((result) => {
          if (
            (!result.eksistererDigipost && !result.eksistererSignering) ||
            integrasjonsPartner
          ) {
            setValgtForetak(foretak);
            callBack();
          } else if (
            (result.eksistererSignering && result.eksistererDigipost) ||
            result.eksistererNyva
          ) {
            //eksisterer i begge, kan ikke registreres
            setAlleredeRegistrert(true);
          } else {
            //eksisterer i en av dem, manuell registrering + advarsel
            const eksisterende = result.eksistererDigipost
              ? "DIGIPOST"
              : "SIGNERING";

            navigate(
              `../../${Route.Manuell}/kontaktinfo?eksisterende=${eksisterende}&orgNr=${foretak.foretak.orgnummer}`,
            );
          }
        })
        .catch(() => {
          setCustomError(
            "Klarte ikke å sjekke om foretak er registrert fra før",
          );
        })
        .finally(() => {
          setVelgerForetak(false);
        });
    },
    [navigate, integrasjonsPartner, setCustomError, callBack],
  );

  return { alleredeRegistrert, valgtForetak, velgForetak, velgerForetak };
}
